<div class="modal-container">
  <div class="modal-header">
    <input ngbAutofocus class="no-size" />
    <span class="modal-title">{{ modalOptions.modalTitle }}</span>
    <grid-ui-icon
      type="button"
      class="close-icon"
      aria-label="Cancel"
      data-hook="disclaimer-modal-cancel-button"
      (click)="cancel()"
      ngbTooltip="Close window"
      name="cross"
      data-testid="icon-close-modal"
    >
    </grid-ui-icon>
  </div>
  <div class="modal-body">
    <h2 class="disclaimer-title">Disclaimer</h2>
    <h3 class="disclaimer-subtitle h-sup">Strictly Private & Confidential</h3>
    <div class="disclaimer-container">
      <div class="disclaimer-border">
        <p class="disclaimer-scroll">
          These materials, including any updates to them, are published by and remain subject to the copyright of the Maplecroft.Net Limited
          ("Verisk Maplecroft"), and are made available to clients of Verisk Maplecroft under terms agreed between Verisk Maplecroft and
          those clients. The use of these materials is governed by the terms and conditions of the agreement under which they were provided.
          The content and conclusions contained are confidential and may not be disclosed to any other person without Verisk Maplecroft’s
          prior written permission. Verisk Maplecroft makes no warranty or representation about the accuracy or completeness of the
          information and data contained in these materials, which are provided 'as is'. The opinions expressed in these materials are those
          of Verisk Maplecroft, and nothing contained in them constitutes an offer to buy or to sell securities, or investment advice.
          Verisk Maplecroft’s products do not provide a comprehensive analysis of the financial position or prospects of any company or
          entity and nothing in any such product should be taken as comment regarding the value of the securities of any entity. Verisk
          Maplecroft does not warrant or represent that these materials are appropriate or sufficient for your purposes. If, notwithstanding
          the foregoing, you or any other person relies upon these materials in any way, Verisk Maplecroft does not accept, and hereby
          disclaims to the extent permitted by law, all liability for any loss and damage suffered arising in connection with such reliance.
          Please also note that the laws of certain jurisdictions may prohibit or regulate the dissemination of certain types of information
          contained in these materials, such as maps, and accordingly it is your responsibility to ensure that any dissemination of such
          information across national boundaries within your organisation is permitted under the laws of the relevant jurisdiction.
          Copyright © {{ fullYear }}, Verisk Maplecroft Limited. All rights reserved. Verisk Maplecroft is a Verisk business.
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    @if (modalOptions.backButtonEnabled) {
      <button
        data-hook="disclaimer-modal-back-button"
        class="btn mc-btn-secondary btn-modal back-button me-auto"
        (click)="onBack()"
        data-testid="btn-back"
      >
        {{ modalOptions.back }}
      </button>
    }
    <button
      class="btn mc-btn-secondary btn-modal cancel-button ms-auto"
      data-hook="disclaimer-modal-decline-button"
      (click)="onDeclineClick()"
      data-testid="btn-decline"
    >
      {{ modalOptions.decline }}
    </button>
    <button
      class="btn mc-btn-primary accept-button"
      data-hook="disclaimer-modal-accept-button"
      (click)="onAcceptClick()"
      data-testid="btn-accept"
    >
      {{ modalOptions.accept }}
    </button>
  </div>
</div>
